import { NotificationVariants } from '@/common/components';
import { useAddNotification } from '@/modules/notifications/store';
import { COMMON_TRANSLATION } from '@/common/constants';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CopyToClipboardResult {
  result: null | { state: 'success' } | { state: 'error' };
  copy: (text: string) => Promise<void>;
}

export const useCopyToClipboard = (): CopyToClipboardResult => {
  const [result, setResult] = useState<null | { state: 'success' } | { state: 'error' }>(null);
  const addNotification = useAddNotification();
  const { t } = useTranslation(COMMON_TRANSLATION);

  useEffect(() => {
    if (result?.state === 'error') {
      addNotification({
        title: t('copy_to_clipboard_failed'),
        type: NotificationVariants.ERROR,
        autoClose: true,
      });
    }
    if (result?.state === 'success') {
      addNotification({
        title: t('copy_to_clipboard_success'),
        type: NotificationVariants.SUCCESS,
        autoClose: true,
      });
    }
  }, [result, addNotification, t]);

  const copy = async (text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      setResult({ state: 'success' });
    } catch (e) {
      setResult({ state: 'error' });
    }
  };

  return { copy, result };
};
